import { styled } from '@mui/material';

import type { Base64ImageProps } from '@ui/atoms-base64-image';
import { Base64Image } from '@ui/atoms-base64-image';

export const PhotoOtpImage = (props: Base64ImageProps) => {
  return <Image {...props} />;
};

const Image = styled(Base64Image)(({ theme }) => ({
  width: `100%`,
  margin: theme.spacing(4, 'auto'),

  [theme.breakpoints.up('2xs')]: {
    margin: theme.spacing(8, 'auto'),
    width: '80%',
  },
}));
